/**
 * Cache configuration - inlined from @hostel-manager/shared
 * to avoid CJS/ESM interop issues during Vite build.
 * Keep in sync with shared/src/config/cache-config.ts
 */
export const CACHE_KEYS = {
  RESIDENTS: 'residents',
  PAYMENTS: 'payments',
  EXPENSES: 'expenses',
  BEDS: 'beds',
  DASHBOARD: 'dashboard',
  REPORTS_TRENDS: 'reports_trends',
  OFFLINE_QUEUE: 'offline_queue',
  READ_ONLY_MODE: 'read_only_mode',
  LAST_SYNC: 'last_sync',
} as const;

export const CACHE_EXPIRATION_MS = {
  residents: 5 * 60 * 1000,
  payments: 10 * 60 * 1000,
  expenses: 15 * 60 * 1000,
  beds: 30 * 60 * 1000,
  dashboard: 2 * 60 * 1000,
  reportsTrends: 5 * 60 * 1000,
  default: 10 * 60 * 1000,
} as const;

export const CACHE_STORAGE_LIMITS = {
  maxTotalSizeBytes: 4 * 1024 * 1024,
  maxPerKeyBytes: 512 * 1024,
  evictionThresholdPercent: 90,
} as const;

export const CACHE_INVALIDATION = {
  invalidateOnWrite: true,
  maxStaleAgeMs: 24 * 60 * 60 * 1000,
  protectedKeys: [CACHE_KEYS.OFFLINE_QUEUE, CACHE_KEYS.LAST_SYNC] as const,
} as const;

export const OFFLINE_QUEUE_CONFIG = {
  maxQueueSize: 100,
  retryDelayMs: 5000,
  maxRetries: 3,
} as const;
